import { Component, OnInit, NgModule, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, FormsModule } from '@angular/forms';
import { CrudService } from './../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';
import * as moment from 'moment';

import { Mensaje } from '../../../mensaje';
import { NotificationsService } from 'angular2-notifications';
import { setInterval } from 'timers';

@Component({
  selector: 'app-alumno-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  @ViewChild('ctrl') ctrl;
  data: FormGroup;
  // data_filtro: FormGroup;

  /**
   * Filtros.
   * @type {string} */
  filtro = false;
  ver = false;
  en_incorporacion = 0;
  grupos_id = '';
  nombreGrupo = '';
  carreras_planes_id = '';
  periodos_escolares_id = '';

  tamano = document.body.clientHeight;
  permisos = JSON.parse(localStorage.getItem("permisos"));
  color = [];
  respuesta: any[] = [];
  mensajeResponse: Mensaje = new Mensaje(true);

  grupos:any[] = [];

  form_personas_rfcs;
  form_personas_cupones;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private crudService: CrudService, private notificacion: NotificationsService) { }

  ngOnInit() {
    //console.log(moment().format('YYYY-MM-DD H:m:s'))
    this.data = this.fb.group({
      id: [''],
      alumnos_inicializacion: this.fb.group({
        nivel: [1],
        mes: [0],
        inicializado: [1],
        completado: [0],
        ultimo_abono: ['']
      }),
      personas_rfcs: this.fb.array([]),
      personas_cupones: this.fb.array([])
    });

    // this.data_filtro = this.fb.group({
    //   en_incorporacion: ['0'],
    //   grupos_id: [''],
    //   carreras_planes_id: [''],
    //   periodos_escolares_id:  ['']
    // });

    this.form_personas_rfcs = {
      tipo_persona: ['Fisica', [Validators.required]],
      rfc: ['', [Validators.required]],
      razon_social: ['', [Validators.required]],
      paises_id: [1],
      estados_id: [7],
      municipios_id: [180],
      localidad: [''],
      colonia: [''],
      calle: [''],
      numero_exterior: [''],
      numero_interior: [''],
      codigo_postal: [''],
      email: [''],
      predeterminado: [0]
    };

    this.form_personas_cupones = {
      articulos_id: ['', [Validators.required]],
      importe: [''],
      codigo: [''],
      inicio_vigencia: [''],
      fin_vigencia: [''],
      utilizado: [0],
    };

    document.getElementById("catalogos").click();
  }

  abrirModal(id, item, i) {
    // this.data.reset();
    this.data = this.fb.group({
      id: [item.id],
      alumnos_inicializacion: this.fb.group({
        nivel: [1],
        mes: [0],
        inicializado: [1],
        completado: [0],
        ultimo_abono: ['']
      }),
      personas_rfcs: this.fb.array([]),
      personas_cupones: this.fb.array([])
    });


    if (item.personas_rfcs.length>0) {
      let rfc = <FormArray>this.data.controls.personas_rfcs;
      item.personas_rfcs.forEach(element => {
        rfc.push(this.fb.group(element));
        // this.data.controls.personas_rfcs['controls'].push(this.fb.group(element));
      });
    }
    if (item.personas_cupones.length>0) {
      let cupones = <FormArray>this.data.controls.personas_cupones;
      item.personas_cupones.forEach(element => {
        cupones.push(this.fb.group(element));
      });
    }
    document.getElementById(id).classList.add('is-active');
  }

  cancelarModal(id) {
    document.getElementById(id).classList.remove('is-active');
  }

  cancelarFiltros(id) {
    document.getElementById(id).classList.remove('is-active');
  }

  guardar(id, ruta) {
    this.crudService.editar(id, this.data.value, ruta).subscribe(
      resultado => {
        this.mensajeResponse.titulo = ruta;
        this.mensajeResponse.texto = resultado.messages;
        this.mensajeResponse.mostrar = true;
        if (resultado.status == 201)  {
          this.mensajeResponse.clase = 'success';
          document.getElementById("cargar_datos_actualizar").click();
        }  else {
          this.mensajeResponse.clase = 'warning';
        }
        this.mensaje(3);
        this.color[id] = true;
        this.cancelarModal(ruta);

        setTimeout(() => {
          this.color[id] = false;
        }, 3500);
      },
      error => {
        this.mensajeResponse.titulo = ruta;
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'error';
        this.mensaje(3);
        this.cancelarModal(ruta);
      }
    );
  }

  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };


  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  grupo_carrera_plan() {
    this.grupos = [];
    if (this.carreras_planes_id!='') {
      this.crudService.lista(this.parametros, 'grupo?carreras_planes_id='+this.carreras_planes_id+'&periodos_escolares_id='+this.periodos_escolares_id).subscribe(
        resultado => {
          if(resultado!=null)
            this.grupos = resultado.data;
        },
        error => {
        }
      );
    }
  }

  /**
   * Este método
   * @return void
   */
  fNombreGrupo(){
    this.grupos.forEach(element => {
      if(element.id==this.grupos_id){
        this.nombreGrupo = element.clave;;
        return false;
      }
    });
  }

  agregar_form_array(modelo, formulario) {
    (<FormArray>modelo).push(this.fb.group(formulario));
  }

  quitar_form_array(modelo, i: number) {
    modelo.removeAt(i);
  }

  predeterminado(modelo){
    this.data.controls.personas_rfcs['controls'].forEach(element => {
      element.controls.predeterminado.patchValue(0);
    });

    modelo.patchValue(1);
  }
}
